export function checkWebSocketConnectivity(url: string) {
	// we don't want WS connection to be established during SSR
	if (typeof window != 'undefined' && typeof window.WebSocket !== 'undefined') {
		try {
			const ws = new window.WebSocket(url, 'graphql-ws');
			ws.onopen = () => {
				setTimeout(() => {
					// do not pollute connection pool, but do not disconnect immediately as it causes error
					// "WebSocket is closed before the connection is established."
					ws.close();
				}, 100);
			};
			return true;
		} catch (error) {
			/* NOOP */
		}
	}

	return false;
}
